module.exports = __webpack_public_path__ + "media/images/vp/icon.switcher.off.white-6f7cbc5e9c4b37d4136aa01d1efcfe4c.png";